var map = {
	"./bagno1.jpg": 980,
	"./bagno2.jpg": 158,
	"./bagno3.jpg": 957,
	"./bagno4.jpg": 220,
	"./camera1.jpg": 44,
	"./cucina1.jpg": 892,
	"./fotor-ai-20230518112130.jpg": 803,
	"./fotor-ai-2023051811221.jpg": 586,
	"./fuori1.jpg": 531,
	"./letto1.jpg": 395,
	"./letto2.jpg": 432,
	"./letto3.jpg": 637,
	"./letto4.jpg": 763,
	"./phone.jpg": 836,
	"./salone1.jpg": 16,
	"./salone2.jpg": 927,
	"./salone3.jpg": 582,
	"./salone4.jpg": 174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;